export default __webpack_public_path__ + "static/media/ic_afghanistan.669049d5.svg";